import type { Announcement } from '../types';

export const a_2026_11_02: Announcement = {
  id: '2026-11-02-plusieurs-dossiers',
  date: '2026-11-02',
  layout: 'spotlight',
  kicker: 'Mise à jour produit · 2 novembre 2026',
  title: "Hector s'améliore : plusieurs dossiers dans une même conversation",
  navLabel: 'Plusieurs dossiers',
  subtitle: '',
  intro: [
    'Une conversation avec Hector peut maintenant porter sur **plusieurs dossiers à la fois** : votre dossier principal, et les dossiers connexes que vous lui ajoutez. Hector lit leurs pièces et leurs écritures pour vous répondre.',
  ],
  sections: [
    {
      label: 'Ce que vous pouvez lui demander',
      features: [
        {
          id: 'comparer-dossiers',
          title: 'Comparer deux dossiers voisins',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              '« Compare les deux rapports d’expertise des dossiers Martin et Durand » : Hector met les deux dossiers en regard, pièces à l’appui, et dit ce que vous pouvez en tirer.',
            ],
          },
        },
        {
          id: 'reprendre-argumentation',
          title: 'Reprendre une argumentation déjà construite',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              '« Reprends l’argumentation sur la clause de non-concurrence du dossier Lefèvre » : Hector la retrouve dans les écritures de ce dossier et l’adapte aux faits et aux pièces du vôtre.',
            ],
          },
        },
        {
          id: 'point-client',
          title: 'Faire le point sur tous les dossiers d’un client',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              '« Fais le point sur tous les litiges de la SCI Les Tilleuls » : Hector retrouve les dossiers de ce client, vous laisse choisir, puis résume chacun et les liens entre eux.',
            ],
          },
        },
        {
          id: 'citer-piece-autre-dossier',
          title: 'Citer une pièce d’un autre dossier',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              '« Retrouve le courrier de résiliation dans le dossier Martin » : Hector cite la pièce, et un clic l’ouvre dans son propre dossier.',
            ],
          },
        },
        {
          id: 'retrouver-conversation',
          title: 'Retrouver ce qui a été dit sur un dossier',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              '« Qu’avait-on dit sur le dossier Durand ? » : Hector retrouve aussi les conversations où ce dossier n’était qu’un dossier connexe.',
            ],
          },
        },
        {
          id: 'ajouter-en-cours',
          title: 'Ajouter un dossier en cours de conversation',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              'Un dossier devient utile au milieu d’un échange ? Ajoutez-le avec le bouton « + » à côté du dossier, sous la zone de saisie, ou demandez-le à Hector : la conversation continue avec les deux dossiers.',
            ],
          },
        },
      ],
    },
  ],
  footer: {
    text: 'Comparer deux dossiers, reprendre une argumentation et faire le point sur un client figurent aussi dans les actions rapides de l’assistant du dossier.',
  },
};
